// Crie um novo arquivo: src/modules/maintenances/components/modals/ContestModal.tsx

import { useState } from "react";
import { Modal, Button, Textarea, Label } from "flowbite-react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (message: string) => void;
  isSubmitting: boolean;
};

export default function ContestModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
}: Props) {
  const [message, setMessage] = useState("");

  const handleSubmit = () => {
    if (message.trim()) {
      onSubmit(message);
    }
  };

  return (
    <Modal show={isOpen} onClose={onClose}>
      <Modal.Header>
        <h2 className="text-black">Contestar Manutenção</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
          <div>
            <Label htmlFor="contest-message" value="Motivo da Contestação" />
            <Textarea
              id="contest-message"
              placeholder="Descreva o motivo da sua contestação aqui..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows={4}
              className="!text-black"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button color="gray" onClick={onClose} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button
          color="failure"
          onClick={handleSubmit}
          isProcessing={isSubmitting}
          disabled={!message.trim() || isSubmitting}
        >
          Enviar Contestação
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
